import React, { useEffect } from 'react'
import { string, object } from 'prop-types'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'overmind-react'
import { DreamCatcher } from '@creditas/dream-catcher'
import { Toaster } from '@creditas-ui/react'
import { SplitFactory } from '@splitsoftware/splitio-react'
import { ThemeProvider } from './providers'
import { getSplitIOConfig } from '~/utils/split-io'
import { overmind } from '~context'
import i18n from '~/i18n/i18n'
import { ReferrerProvider } from '~/utils/context/Referrer'
import { AppRouter } from '~/router'

const APP_URL = process.env.APP_URL || ''
const PORTAL_URL = process.env.PORTAL_URL || ''

const SingleSpaContext = React.createContext(null)

const RootApp = props => {
  return (
    <SplitFactory config={getSplitIOConfig()}>
      <Provider value={overmind}>
        <ReferrerProvider>
          <I18nextProvider i18n={i18n}>
            <ThemeProvider>
              <Toaster />
              <AppRouter {...props} />
            </ThemeProvider>
          </I18nextProvider>
        </ReferrerProvider>
      </Provider>
    </SplitFactory>
  )
}

RootApp.propTypes = {
  appUrl: string,
  portalUrl: string,
}

RootApp.defaultProps = {
  appUrl: APP_URL,
  portalUrl: PORTAL_URL,
}

const App = props => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.singleSpa = props.singleSpa
      const DC = new DreamCatcher()
      DC.init()
    }
  }, [])

  return (
    <SingleSpaContext.Provider value={props.singleSpa}>
      <RootApp
        name={props.name}
        appUrl={props.appUrl}
        portalUrl={props.portalUrl}
      />
    </SingleSpaContext.Provider>
  )
}

App.propTypes = {
  singleSpa: object,
  name: string,
  appUrl: string,
  portalUrl: string,
}

App.displayName = 'RootApp'

class SingleSpaApp extends React.Component {
  componentDidCatch(err) {
    throw new Error(err)
  }

  render() {
    return <App {...this.props} />
  }
}

export { SingleSpaApp as App }
